import { LinearGradient } from "react-text-gradients";
import { useEffect } from "react";
import { FaRegCalendarDays, FaLocationDot } from "react-icons/fa6";
import { AddressInfo } from "../WeddingInfo/WeddingInfo";

interface InstaLocationProps {
  instaLocation: AddressInfo;
  weddingDate: string;
}

const InstaLocation: React.FC<InstaLocationProps> = ({
  instaLocation,
  weddingDate,
}) => {
  const clientId = "ppr0w7ahcd";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${clientId}`;
    script.async = true;
    script.onload = () => {
      const map = new window.naver.maps.Map("map", {
        center: new window.naver.maps.LatLng(
          instaLocation.lat,
          instaLocation.lon
        ),
        zoom: 16, // 기본 zoom 값
      });

      // 기본 마커 추가 (커스텀 이미지 제거)
      new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(
          instaLocation.lat,
          instaLocation.lon
        ),
        map,
      });
    };

    document.body.appendChild(script);
  }, []);

  // 네이버 지도에서 내 위치로 오시는 길 열기
  const handleNavigateToNaverMap = () => {
    const webUrl = instaLocation.naverAddress;
    window.open(webUrl, "_blank");
  };

  return (
    <div>
      <div className="flex items-center space-x-2 mt-12 mb-6 mx-4">
        <div className="relative w-10 h-10 rounded-full border-[1px] border-gray-200 flex items-center justify-center">
          <FaLocationDot className="w-5 h-5" />
        </div>
        <div className="font-instagram-logo text-3xl text-left">Location</div>
      </div>

      <div className="flex space-x-2 mb-1 mx-16 rounded-lg shadow-all-around items-center justify-center font-gowun">
        <div className="font-bold text-sm py-2 px-4">
          {instaLocation.address} <br />
          {instaLocation.name}
        </div>
      </div>

      <div className="mt-4">
        <div className="w-full max-w-md mt-4 flex justify-center flex-col items-center">
          {/* 지도 */}
          <div
            id="map"
            className="w-[300px] h-[300px] rounded-lg shadow-md"
          ></div>

          {/* 네이버 길찾기 버튼 */}
          <button
            onClick={handleNavigateToNaverMap}
            className="font-gowun mt-6 text-white font-bold py-2 px-6 rounded-lg transition bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7]"
          >
            📍 네이버로 길 찾기
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstaLocation;
